import { useLocation } from "@tanstack/react-router";

export enum VIEW_TYPE {
  COMPANY = "unternehmen",
  ACCOUNTING = "buchhaltung",
}

export const useGetView = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const accountingView = pathname.includes(VIEW_TYPE.ACCOUNTING);
  const companyView = pathname.includes(VIEW_TYPE.COMPANY);

  if (accountingView) {
    return VIEW_TYPE.ACCOUNTING;
  }

  if (companyView) {
    return VIEW_TYPE.COMPANY;
  }

  return VIEW_TYPE.ACCOUNTING;
};
